import React from 'react';
import styled from './HtmlCell.module.css';
import { CellProps } from 'react-table';

const HtmlCell = (props: CellProps<any>) => {
    return <div className={styled.HtmlCell} dangerouslySetInnerHTML={{ __html: props.cell.value }} />;
};

export default HtmlCell;
